import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsBetRecordQuery implements ICommand
{

	public GameID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameID = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsBetRecordQuery();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameID(Q)='+this.GameID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55107;
	}

	public getCmdName() : string
	{
		return 'PsBetRecordQuery';
	}

}
